import { useActions } from 'react-redux-actions-hook'

import {
  saveNote,
  saveVendorCode,
} from '@/checkout-instore-legacy/order/actions'

export const useOrderNoteActions = () => {
  const actions = useActions({ saveNote, saveVendorCode }, [])

  return {
    ...actions,
  }
}
